/**
 * @group Auth
 * @summary Authentication messages for the auth module
 * 
 * @remarks
 * This constant contains authentication messages for errors and success states
 * in the authentication system.
 * 
 * @example
 * ```typescript
 * import { AUTH_MESSAGES } from '@shared/constants';
 * 
 * if (!email || !password) {
 *   throw new Error(AUTH_MESSAGES.ERRORS.EMAIL_PASSWORD_REQUIRED);
 * }
 * ```
 */
export const AUTH_MESSAGES = {
  ERRORS: {
    EMAIL_PASSWORD_REQUIRED: 'Email and password are required',
    USER_EXISTS: 'User with this email already exists',
    DATABASE_CONNECTION: 'Database connection error',
    SIGNUP_GENERIC: 'An error occurred during signup',
    AUTHENTICATION_ERROR: 'Authentication error:',
    DEFAULT_TENANT_NOT_FOUND: 'Default tenant not found'
  },
  SUCCESS: {
    USER_CREATED: 'User created successfully'
  }
} as const; 